import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'
import t from '~/scopes/campaign/data/metals/tin.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['ademe2024'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['usgsMcs2025', 'ademe2024', 'pulitzerTinIslands2025'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['pulitzerTinIslands2025', 'bgrTin2020'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['pulitzerTinIslands2025', 'bgrTin2020'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: ['pulitzerTinIslands2025', 'bgrTin2020'],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['afrewatchDeforestation2026', 'pblEnvironmental2024'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['ademe2024', 'pulitzerTinIslands2025', 'bgrTin2020'],
      },
      blocks: [
        {
          title: SECTIONS.humanDisplacement,
          text: t.humanDisplacementText,
          sourceRefs: ['pulitzerTinIslands2025'],
        },
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['pulitzerTinIslands2025', 'bgrTin2020'],
        },
        {
          title: SECTIONS.humanChildLabour,
          text: t.humanChildLabourText,
          sourceRefs: ['ademe2024', 'pulitzerTinIslands2025', 'bgrTin2020'],
        },
        {
          title: SECTIONS.humanGender,
          text: t.humanGenderText,
          sourceRefs: ['pulitzerTinIslands2025', 'cikuruKamera2026'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: [
            'ieaGcmo2025',
            'pblSocial2025',
            'pulitzerTinIslands2025',
          ],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['ademe2024'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ademe2024'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ieaGcmo2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ademe2024', 'ieaGcmo2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ademe2024', 'ieaGcmo2025', 'ieaMineralsExplorer'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['ieaRecycling2024', 'bgrTin2020'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['usgsMcs2025', 'ieaRecycling2024', 'jrcCircular2017'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['ieaRecycling2024'],
      },
    ],
  },
  // One paragraph, not two: the client's copy breaks the line before the URL, and a bare
  // URL alone is a continuation of its citation rather than a paragraph of its own — the
  // joining concession `data/sources.ts` already documents.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
        },
      ],
    },
  ],
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
  mine4Region: t.mine4Region,
} as const
